<template>
    <div>
        <pda-header title='装箱单扫描'></pda-header>
        <div style="width: 100%;text-align: center;margin-top: 40px">
            <div>
                <input value="1">
                <van-button type="info" @click="getdata()" size="mini" style="margin-left: 10px">扫描</van-button>
            </div>
        </div>
        <div style="" id="yourElement"></div>
    </div>
</template>

<script>
  import Quagga from 'quagga'
  export default {
    name: "FGscan",
    mounted(){
      Quagga.init({
        inputStream : {
          name : "Live",
          type : "LiveStream",
          target: document.querySelector('#yourElement'),    // Or '#yourElement' (optional)
          constraints:{
            facingMode:'environment',
            width: "0",
            height: "0"
          }
        },
        decoder : {
          readers : ["ean_reader","code_128_reader"],
          debug:{
            drawBoundingBox: false,
            showFrequency: false,
            drawScanline: false,
            showPattern: false
          },
          multiple: false
        }
      }, function(err) {
        if (err) {
          alert(err);
          return
        }
        console.log("Initialization finished. Ready to start");
        Quagga.start();
        Quagga.onDetected(function(data){
          console.log(data)
          alert(data.codeResult.code)
        })
      });
    },
    methods:{
      getdata(){
        Quagga.init({
          inputStream : {
            name : "Live",
            type : "LiveStream",
            target: document.querySelector('#yourElement')    // Or '#yourElement' (optional)
          },
          decoder : {
            readers : ["code_128_reader"]
          }
        }, function(err) {
          if (err) {
            console.log(err);
            return
          }
          console.log("Initialization finished. Ready to start");
          Quagga.start();
        });
      }
    }
  }
</script>

<style lang="less">

</style>